<template>
    <button class="chat-copy" @click="onClick" type="button" :class="{ 'is-active': isActive }">
        <svg class="chat-copy__icon" width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.57895 15H1.36842C0.615789 15 0 14.3864 0 13.6364V4.09091H1.36842V13.6364H9.57895V15ZM11.6316 12.2727H4.10526C3.35263 12.2727 2.73684 11.6591 2.73684 10.9091V1.36364C2.73684 0.613636 3.35263 0 4.10526 0H11.6316C12.3842 0 13 0.613636 13 1.36364V10.9091C13 11.6591 12.3842 12.2727 11.6316 12.2727ZM11.6316 1.36364H4.10526V10.9091H11.6316V1.36364Z" fill="white"/>
        </svg>

        <svg class="chat-copy__success-icon"
             x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
	        <circle style="fill:#fff;" cx="25" cy="25" r="25"/>
            <polyline style="fill:none;stroke:#28B764;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" points="38,15 22,33 12,25 "/>
        </svg>
    </button>
</template>

<script>
export default {
    name: "MeetingCopyButton",
    props: {
        value: {
            type: String,
            required: true
        }
    },
    data() {
      return {
          isActive: false
      }
    },
    methods: {
        onClick() {
            this.isActive = true;
            try {
                navigator.clipboard.writeText(this.value);
            }
            finally {
                setTimeout(() => {
                    this.isActive = false;
                }, 1000)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.chat-copy {
    background: rgba(0,0,0,0);
    box-shadow: none;
    border: 0;
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    flex: 0 0 13px;
    width: 13px;
    height: 15px;
    position: relative;

    &__icon {
        width: 100%;
        height: 100%;
        opacity: 1;
        transition: all .3s ease;

        &:hover {
            path {
                fill: darken(#fff, 10%);
            }
        }
    }

    &:focus, &:active {
        outline: none;
        -webkit-tap-highlight-color: transparent;
    }

    &__success-icon {
        position: absolute;
        left: 50%;
        width: 100%;
        top: 50%;
        transform: translate(-50%, -50%);
        filter: drop-shadow(0 0 3px rgba(0,0,0,0.2));
        visibility: hidden;
        opacity: 0;
        transition: all .3s ease;
    }

    &.is-active {
        .chat-copy__success-icon {
            visibility: visible;
            opacity: 1;
            transform: translate(-50%, -50%) scale(1.2);
        }

        .chat-copy__icon {
            opacity: 0;
        }
    }
}
</style>
